<kendo-grid
  *ngIf="canProcess"
  class="grid"
  [ngClass]="{ 'grid-full-size': fullSize }"
  [loading]="isLoading"
  [data]="instanceOptions"
  [resizable]="true"
>
  <kendo-grid-column field="title" title="Model">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>
        {{ dataItem.label }}
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="title" title="URL">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>
        {{ dataItem.url }}
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="canCreate" title="Access" [width]="100">
    <ng-template kendoGridCellTemplate let-dataItem>
      <mat-checkbox
        [disabled]="isReadOnly || !editingMode"
        class="checkbox-crud"
        [checked]="dataItem.canAccess"
        (change)="savegroupModelCrud($event.source, $event.checked, dataItem)"
      >
      </mat-checkbox>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
<!-- 
(change)="crudChanged($event, dataItem, 'canRead')" -->
